import PaginatedTable from "@/components/UI/PaginatedTable";
import ErrorComponent from "@/components/UI/Error";
import Loader from "@/components/UI/Loader";
import DiscrepanciesDrawer from "@/views/DataDiscrepancies/Drawer";
import type {
  Discrepancy,
  DiscrepanciesDataTableProps,
} from "@/views/DataDiscrepancies/dataDiscrepancies.types";

type TableFooterProps = {
  rowCount: number;
  selectedCount?: number;
};

const TableFooter = ({ rowCount, selectedCount }: TableFooterProps) => (
  <div className="flex gap-4">
    <p className="font-bold" data-testid="table-total-records">
      Total records: {rowCount}
    </p>
    {selectedCount !== undefined && selectedCount !== rowCount && (
      <p className="font-bold">Selected records: {selectedCount}</p>
    )}
  </div>
);

export const DiscrepanciesDataTable = ({
  data,
  columns,
  loading,
  error,
  pagination,
  setPagination,
  rowCount,
  selectedCount,
  selectedRecord,
  setSelectedRecord,
  queryKey,
  availableAssignees,
  assigneeIdToName,
  onAssignmentChange,
}: DiscrepanciesDataTableProps) => (
  <>
    {error && <ErrorComponent />}

    {!error && loading && (
      <div className="flex justify-center items-center h-125">
        <Loader noMargin />
      </div>
    )}

    {!error && !loading && (
      <PaginatedTable
        data={data}
        columns={columns}
        loading={loading}
        setPagination={setPagination}
        pagination={pagination}
        onRow={(record: Discrepancy) =>
          ({
            "data-testid": `issue-row-${record.discrepancy_id}`,
          }) as any
        }
        footer={() => (
          <TableFooter rowCount={rowCount} selectedCount={selectedCount} />
        )}
      />
    )}

    <DiscrepanciesDrawer
      selectedRecord={selectedRecord}
      setSelectedRecord={setSelectedRecord}
      queryKey={queryKey}
      availableAssignees={availableAssignees}
      assigneeIdToName={assigneeIdToName}
      onAssignmentChange={onAssignmentChange}
    />
  </>
);
